import { Container } from "@/components/layouts/container";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_backoffice")({
	beforeLoad: ({ context }) => {
		if (!context.auth.user) {
			throw redirect({
				to: "/login",
			});
		}
	},
	component: BackOfficeLayout,
});

function BackOfficeLayout() {
	return (
		<Container>
			<Outlet />
		</Container>
	);
}
